// src/screens/DeveloperToolsScreen.js

import React, { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import UserManagementTab from "../components/developer/UserManagementTab";
import SystemToolsTab from "../components/developer/SystemToolsTab";
import DeveloperLogsTab from "../components/developer/DeveloperLogsTab";

const DeveloperToolsScreen = () => {
  const [activeTab, setActiveTab] = useState("users");
  const [loading, setLoading] = useState(true);
  const [isDevAccount, setIsDevAccount] = useState(false);

  useEffect(() => {
    const auth = getAuth();
    const unsub = onAuthStateChanged(auth, (user) => {
      const email = String(user?.email || "").trim().toLowerCase();
      setIsDevAccount(email === "roserobin13@gmail.com");
      setLoading(false);
    });

    return () => unsub();
  }, []);

  if (loading) {
    return (
      <div className="w-full max-w-none mx-0 px-0 py-1">
        <div className="rounded-xl border border-slate-200 bg-white px-4 py-6 text-sm text-slate-500">
          Loading Developer Tools…
        </div>
      </div>
    );
  }

  if (!isDevAccount) {
    return (
      <div className="w-full max-w-none mx-0 px-0 py-1">
        <div className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-6">
          <h1 className="text-base font-semibold text-amber-900">Developer Tools locked</h1>
          <p className="mt-1 text-sm text-amber-800">
            This area is only available to the SupplyHawk developer account.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full max-w-none mx-0 px-0 py-1">
      <div className="mb-4">
        <h1 className="text-lg font-semibold text-gray-900">
          Developer Tools
        </h1>
        <p className="text-xs text-gray-500">
          Only visible to dev accounts. Use with care.
        </p>
      </div>

      {/* Tab Navigation */}
      <div className="flex gap-2 mb-4 border-b border-gray-200">
        <button
          onClick={() => setActiveTab("users")}
          className={`px-4 py-2 text-sm font-medium transition-colors relative ${
            activeTab === "users"
              ? "text-blue-600 border-b-2 border-blue-600 -mb-px"
              : "text-gray-600 hover:text-gray-900"
          }`}
        >
          User & Company Management
        </button>
        <button
          onClick={() => setActiveTab("system")}
          className={`px-4 py-2 text-sm font-medium transition-colors relative ${
            activeTab === "system"
              ? "text-blue-600 border-b-2 border-blue-600 -mb-px"
              : "text-gray-600 hover:text-gray-900"
          }`}
        >
          System Tools & Links
        </button>
        <button
          onClick={() => setActiveTab("logs")}
          className={`px-4 py-2 text-sm font-medium transition-colors relative ${
            activeTab === "logs"
              ? "text-blue-600 border-b-2 border-blue-600 -mb-px"
              : "text-gray-600 hover:text-gray-900"
          }`}
        >
          Audit & Error Logs
        </button>
      </div>

      {/* Tab Content */}
      <div className="mt-4">
        {activeTab === "users" && <UserManagementTab />}
        {activeTab === "system" && <SystemToolsTab />}
        {activeTab === "logs" && <DeveloperLogsTab />}
      </div>
    </div>
  );
};

export default DeveloperToolsScreen;
